import React from 'react'
import {
	AvailabilityContainer,
	AvailabilityItem,
	Container,
} from './Avalability.style'
import LighterText from 'components/Text/Lighter'

interface AvailabilityProps {
	title?: string;
	availability: Array<number>;
	onClick?: () => any;
}

const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

export default class Availability extends React.Component<AvailabilityProps> {

	render() {
		return (
			<Container {...this.props}>
				<LighterText>{this.props.title}</LighterText>
				<AvailabilityContainer>
					{
						days.map((day: string, index: number) => (
							<AvailabilityItem
								onClick={this.props.onClick}
								key={index}
								active={
									this.props.availability[index] === 1
										? String(index)
										: 'false'
								}
							>
								{day}
							</AvailabilityItem>
						))
					}
				</AvailabilityContainer>
			</Container>
		)
	}
}
